import styled from 'styled-components';

import { warningYellowIcon } from '#/assets';
import { useRfqBuilderView } from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/view';

export default function Warning() {
  const view = useRfqBuilderView();

  // Stacked rather than exclusive: mixed contract multipliers are one of the
  // rules structureError reports, so the clearing-currency note is most worth
  // showing exactly when a structure error is up.
  const structureWarning =
    view.structureError != null ? (
      <WarningContainer>
        <Icon />
        <PrimaryMessage>{view.structureError}</PrimaryMessage>
      </WarningContainer>
    ) : null;

  const firstFutureLeg = view.legs.find((leg) => leg.kind === 'FUTURE');
  const productCode = firstFutureLeg?.product.selectedOption?.value;
  const isDrfq = view.auction.selectedOption.value === 'RFQ';

  let contractSizeWarning = null;
  if (firstFutureLeg != null && productCode != null) {
    contractSizeWarning = isDrfq ? (
      <WarningContainer>
        <ContractSizeWarning />
      </WarningContainer>
    ) : (
      <span />
    );
  }

  if (structureWarning == null && contractSizeWarning == null) return null;

  return (
    <>
      {structureWarning}
      {contractSizeWarning}
    </>
  );
}

const WarningContainer = styled.div`
  padding: 5px 10px;
  font-size: 12px;
`;

function ContractSizeWarning() {
  return (
    <>
      <Icon />
      <PrimaryMessage>
        All Qty units are in clearing currency terms.
      </PrimaryMessage>{' '}
      <SecondaryMessage>
        Exchange & product specific contract multipliers are not applied.
      </SecondaryMessage>
    </>
  );
}

const Icon = styled.img.attrs({ src: warningYellowIcon, alt: 'warning' })`
  width: 18px;
  margin-right: 7px;
  margin-top: -1px;
`;
const PrimaryMessage = styled.span`
  color: #fff;
`;
const SecondaryMessage = styled.span`
  color: rgba(255, 255, 255, 0.5);
`;
